<template>
    <div class="rtb-money-lines" :class="{ 'rtb-money-lines--boxed': boxed }">
        <div
            v-for="col in columns"
            :key="col.key"
            class="rtb-money-line"
            :class="{ 'rtb-money-line--boxed': boxed }"
        >
            <span class="rtb-money-line__label">{{ col.label }}</span>
            <span class="rtb-money-line__value">
                {{ formatMoney(col.spent) }}
                <span v-if="showLimit && col.limit" class="rtb-money-line__limit">
                    / {{ formatMoney(col.limit) }}
                </span>
            </span>
            <span v-if="showToday" class="rtb-money-line__today">
                сегодня {{ formatMoney(col.spent_today) }}
                <template v-if="showLimit && col.limit_daily">
                    / {{ formatMoney(col.limit_daily) }}
                </template>
            </span>
            <span v-if="showAvg" class="rtb-money-line__avg">{{ avgText(col) }}</span>
            <span v-if="showRemaining && col.remaining != null" class="rtb-money-line__remain">
                остаток {{ formatMoney(col.remaining) }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RtbMoneyLines',
    props: {
        columns: { type: Array, default: () => [] },
        showLimit: { type: Boolean, default: false },
        showToday: { type: Boolean, default: false },
        showAvg: { type: Boolean, default: false },
        showRemaining: { type: Boolean, default: false },
        impressions: { type: Number, default: 0 },
        precise: { type: Boolean, default: false },
        boxed: { type: Boolean, default: false },
    },
    methods: {
        formatMoney(val) {
            const nf = new Intl.NumberFormat('ru-RU', {
                style: 'currency',
                currency: 'KZT',
                currencyDisplay: 'symbol',
                minimumFractionDigits: this.precise ? 2 : 0,
                maximumFractionDigits: this.precise ? 4 : 2,
            });
            const n = Number(val);
            return nf.format(Number.isFinite(n) ? n : 0);
        },
        avgText(col) {
            const impr = Number(this.impressions) || 0;
            if (impr <= 0) return '—';
            const avg = (Number(col.spent) || 0) / impr;
            return `${this.formatMoney(avg)} / показ`;
        },
    },
};
</script>

<style scoped>
.rtb-money-lines {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.rtb-money-lines--boxed {
    gap: 8px;
}

.rtb-money-line {
    display: flex;
    flex-direction: column;
    gap: 1px;
    line-height: 1.25;
}

.rtb-money-line--boxed {
    padding: 6px 8px;
    background: #f9fafb;
    border: 1px solid #eef0f2;
    border-radius: 6px;
}

.rtb-money-line__label {
    font-size: 11px;
    color: #6b7280;
}

.rtb-money-line__value {
    font-size: 13px;
    color: #111827;
    font-weight: 500;
}

.rtb-money-line__limit,
.rtb-money-line__today,
.rtb-money-line__avg,
.rtb-money-line__remain {
    font-size: 11px;
    color: #6b7280;
    font-weight: 400;
}
</style>
